import grapesjs from 'grapesjs';
import loadComponents from './components';
// eslint-disable-next-line no-unused-vars
import loadBlocks from './blocks';

export default grapesjs.plugins.add('display-rss-plugin', (editor, opts = {}) => {
  // Add components
  loadComponents(editor, opts);

  // RSS continuent de s'ouvrir et de s'afficher normalement.
  // Pour le réactiver : décommenter la ligne ci-dessous.
  // loadBlocks(editor, opts);
});



// WEBPACK FOOTER //
// ./src/plugins/rss/index.js